/** every action's default keys (a module of its own: the tests read it without the game around it) */
export const defaultBinds = Object.freeze({
    "+up": ["W", "ArrowUp"],
    "+down": ["S", "ArrowDown"],
    "+left": ["A", "ArrowLeft"],
    "+right": ["D", "ArrowRight"],
    "interact": ["F"],
    "build_wall": ["B"],
    "gravity_merge": ["V"],
    "gravity_launch": ["Mouse2"],
    // (1.05, at night: the middle mouse button, the owner's first choice; V, his other, is the gloves' merge already:
    // console/bindMoves.ts gives a player whose V is free that too)
    "flashlight": ["Mouse1"],
    "loot": [],
    "slot 0": ["1"],
    "slot 1": ["2"],
    "slot 2": ["3", "E"],
    "equip_or_cycle_throwables 1": ["4"],
    "last_item": ["Q"],
    "other_weapon": ["Space"],
    // (1.06, the owner: "Space to jump"; out of the plane only, and on the ground Space still swaps guns:
    // console/bindMoves.ts gives it a player whose saved keys have Space for something else a free key instead)
    "jump": ["Space"],
    // (1.10, the owner: the Octo Gadget "can also be quick used by pressing shift": an arm out the way you aim, whatever
    // you hold; console/bindMoves.ts leaves a player whose saved keys have Shift for something else without it)
    "octo": ["Shift"],
    "swap_gun_slots": ["T"],
    "cycle_items -1": ["MWheelUp"],
    "cycle_items 1": ["MWheelDown"],
    "+attack": ["Mouse0"],
    "drop": [],
    "reload": ["R"],
    "explode_c4": ["Z"],
    "cycle_scopes -1": [],
    "cycle_scopes 1": [],
    "use_consumable gauze": ["7"],
    "use_consumable medikit": ["8"],
    "use_consumable cola": ["9"],
    "use_consumable tablets": [],
    "use_consumable meat": ["0"],
    "use_consumable vaccine_syringe": ["6"],
    // (0.93: X opens the voice reactions, the owner's choice; cancelling moved to H: console/bindMoves.ts)
    "cancel_action": ["H"],
    "+view_map": [],
    "toggle_map": ["G", "M"],
    "toggle_minimap": ["N"],
    "toggle_inventory": ["Tab", "I"],
    "toggle_hud": [],
    "+emote_wheel": ["Mouse2"],
    "+reaction_wheel": ["X"],
    "+map_ping_wheel": ["C"],
    "fullscreen": [],
    "toggle_console": [],
    "+map_ping": [],
    "toggle_slot_lock": ["L"],
    "screen_record": [],
    "toggle pf_net_graph 0 1 2": []
} as Record<string, string[]>);
